import { Component, computed, inject, input, model, output, signal } from '@angular/core';
import { CustomerService } from '../../../services/customer';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { FORM_FIELD, ValidationError } from '@angular/forms/signals';
import { SpinnerLoaderDirective } from '../../directives/spinner-loader.directive';

@Component({
  selector: 'fs-company-select',
  imports: [SpinnerLoaderDirective],
  templateUrl: './company-select.html',
  styleUrl: './company-select.scss'
})
export class CompanySelect {
  private readonly customerService = inject(CustomerService);
   protected readonly formField = inject(FORM_FIELD, { optional: true });

  readonly value = model<string>('');
  readonly touch = output<void>();
  readonly errors = computed(() => this.formField?.errors() ?? []);
  readonly isInvalid = computed(() => !!this.formField?.state().invalid() && !!this.formField?.state().touched());
  readonly isRequired = computed(() => this.formField?.state().required() ?? false);
  readonly isDisabled = computed(() => this.formField?.state().disabled() ?? false);

  readonly label = input<string>('Azienda');
  readonly isVisibleOptionAll = input<boolean>(true);
 
  companiesResource =  toSignal(this.customerService.getCompaniesList());
  
  
  onSelectionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.value.set(target.value);
    this.touch.emit();
  }

  onBlur() {
    this.touch.emit();
  }
}
